import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useCallback } from 'react';
const styles = css `
  margin-top: 10px;
  padding: 5px;
  text-align: center;

  p {
    font-size: 14px;
  }

  button:focus {
    outline: none;
  }

  button {
    flex: 2;
    padding: 5px;
    border: 1px solid gray;
    border-radius: 5px;
    height: 30px;
    margin: 0 auto;
    margin-top: 15px;
    display: block;
    width: 90px;

    color: white;
    background-color: gray;
  }
`;
function EditLinkConfirmation({ description, onConfirm, }) {
    const handleOnConfirm = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        onConfirm();
    }, [onConfirm]);
    return (_jsxs("div", { css: styles, children: [_jsx("p", { children: description }), _jsx("button", { type: "button", onClick: handleOnConfirm, children: "Confirm" })] }));
}
export default EditLinkConfirmation;
